import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { enableProdMode } from '@angular/core';

import { AppModule } from './app.module';

// Habilitar modo producción para builds optimizados (--prod, --aot, --minifycss)
// Si usas 'ionic serve' para desarrollo, comenta esta línea para tener mejores mensajes de error
enableProdMode();

// Add error handling
platformBrowserDynamic().bootstrapModule(AppModule)
  .catch(err => {
    console.error('Error bootstrapping app:', err);
    document.body.innerHTML = '<h1>Error loading application</h1><p>' + err.message + '</p>';
  });



// WEBPACK FOOTER //
// ./src/app/main.ts